import "./AboutESO.module.css";
import Header from "@/reusable_sections/Header";
import Ambition from "./sections/Ambition";
import Journey from "./sections/Journey";
import CoreValues from "./sections/CoreValues";
import Footer from "@/reusable_sections/Footer";
export default function AboutESOPage() {
  return <div>
      <Header />
      <Ambition />
      <Journey />
      <CoreValues />
      <Footer />
    </div>;
}